import React from 'react';

const SOMaterialOutView = ({ array, selectedRows, onSelectRow, locId }) => {
    return (
        <div>
            {
                array.length > 0 &&

                <>


                    <table>
                        <thead>
                            <th>Sr.No.</th>
                            <th>Location</th>
                            <th>Barcode</th>
                            <th>Material</th>
                            <th>M type</th>
                            <th>Stock P Qty.</th>
                            <th>Issue P Qty.</th>
                            <th>Bal P Qty.</th>
                            <th>Stock Mtr</th>
                            <th>Issue Mtr</th>
                            <th>Bal Mtr</th>
                            <th>Stock Inch</th>
                            <th>Issue Inch</th>
                            <th>Bal Inch</th>
                            <th>Stock Totqty</th>
                            <th>Issue Totqty</th>
                            <th>Bal Totqty</th>
                        </thead>
                        <tbody>
                            {array?.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        {selectedRows &&
                                            <input
                                                type="checkbox"
                                                checked={selectedRows.includes(index)}
                                                onChange={() => onSelectRow(index)}
                                            />}{" "}
                                        {index + 1}</td>
                                    <td>{item.locNm}</td>
                                    <td>{item.barcode}</td>
                                    <td>{item.materialNm}</td>
                                    <td>{item.mtype}</td>
                                    <td>{item.balpqty}</td>
                                    <td>{item.outqty}</td>
                                    <td>{(parseFloat(item.balpqty) - parseFloat(item.outqty)).toFixed(2)}</td>
                                    <td>{item.balmtr}</td>
                                    <td>{item.outMtr}</td>
                                    <td>{(parseFloat(item.balmtr) - parseFloat(item.outMtr)).toFixed(2)}</td>
                                    <td>{item.balInch}</td>
                                    <td>{item.outInch}</td>
                                    <td>{(parseFloat(item.balInch) - parseFloat(item.outInch)).toFixed(2)}</td>
                                    <td>{item.balTotqty}</td>
                                    <td>{item.outBoxQty}</td>
                                    <td>{(parseFloat(item.balTotqty) - parseFloat(item.outBoxQty)).toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>

            }
        </div>
    );
}

export default SOMaterialOutView;
